import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying");
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); return; }
    api.post(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => setStatus("success")).catch(() => setStatus("error"));
  }, [params]);
  return (
    <div className="mx-auto max-w-md p-12 text-center">
      <h1 className="font-display text-2xl tracking-tight">
        {status === "verifying" ? "Verifying…" : status === "success" ? "Email verified!" : "Invalid or expired link"}
      </h1>
    </div>
  );
}
